import React, {Component} from 'react';
import Axios from 'axios';
import AppHeader from '../parts/AppHeader';
import APIENDPOINT from '../ApiEndpoint';


class MethodCardScreen extends Component {
    constructor(props){
        super(props);
        this.state = {
            mcard: [],
            loading: true
        };
    }
    componentDidMount(){

        Axios.get(`${APIENDPOINT}/mcard`)
        .then(response => {
            const {data} = response;
            const pathname = parseInt(window.location.pathname.split("/")[2]);
            const mcard = Object.values(data).find(mcard => mcard.id == pathname);
            this.setState({mcard});
            this.setState({loading: false});
           // console.log(mcard.options["Didactisch Principe"]);
 
        })
        .catch(err => {
            console.log(err);
        })
    }

    typeOptionList = (type) => {
        const mcardOptions = this.state.mcard.options;
        if(mcardOptions[type]){
            return mcardOptions[type].map((element, i) => {
                if(mcardOptions[type].length-1 === i){
                    return (<span key={i}>&nbsp;{element}</span>); 
                }
                return (<span key={i}>&nbsp;{element},</span>);
            })
        }
    }
    render(){

        let favorites = []
        if(localStorage.getItem('favorites')){
            favorites = localStorage.getItem('favorites').split("&").slice(0, -1);
        }

        const mcardOptions = this.state.mcard.options;
        const {mcard} = this.state;
        //BUG! Includes needs to be fixed...
        function addToFavorites(){
            let favorites = []
            if(localStorage.getItem('favorites')){
                favorites = localStorage.getItem('favorites').split("&").slice(0, -1);
            }
            if(!favorites.includes(parseInt(window.location.pathname.split("/")[2])-1)){
                favorites.push(parseInt(window.location.pathname.split("/")[2])-1);

                let result = "";
                favorites.forEach(function(favorite){
                    result+=(favorite+'&');
                });
                localStorage.setItem('favorites', result);
            }
        }


        console.log(mcardOptions);

        return(
            <div>
                <AppHeader titleText="Werkvorm" leftButton='Back' rightButton='Home' backLink='/resultaten' titleTextLink='/resultaten' />
                {this.state.loading ? <div>Aan het laden</div>:
                <main className="werkvormen">
                    <section className="title">
                        <div className="left">
                            <h2>
                                {mcard.title}
                            </h2>
                        </div>
                        <div className="right">
                            <a href="#">
                                <div className={favorites.includes(String(mcard.id)) ? 'favoriet isfavorite' : 'favoriet'} onClick={addToFavorites.bind(this)}></div>
                            </a>
                        </div>
                    </section>
                    <section className="uitleg">
                        <ul>
                            <li>
                                <h3>
                                    Doel
                                </h3>
                                <p>
                                    {mcard.target}
                                </p>
                            </li>
                            <li>
                                <h3>
                                    Korte beschrijving
                                </h3>
                                <p>
                                    {mcard.description}
                                </p>
                            </li>
                            <li>
                                <h3>
                                    Concreet voorbeeld
                                </h3>
                                <p>
                                    {mcard.example}
                                </p>
                            </li>
                            <li>
                                <h3>
                                    Benodigdheden
                                </h3>
                                <p>
                                    {mcard.requirements}
                                </p>
                            </li>
                        </ul>
                    </section>

                    <section className="meerinfo">
                        <ul>
                            <li>
                                <h3>Meer informatie</h3>
                            </li>
                            <li>
                                <p className="left">
                                    Aantal studenten:
                                </p>
                                <p className="right">
                                    {this.typeOptionList("Aantal studenten")}
                                </p>
                            </li>
                            <li>
                                <p className="left">
                                    Soort vak:
                                </p>
                                <p className="right">
                                    {this.typeOptionList("Kennis- of vaardigheidsvak")}
                                </p>
                            </li>
                            <li>
                                <p className="left">
                                    Duur voorbereiding:
                                </p>
                                <p className="right">
                                    {this.typeOptionList("Duur voorbereiding")}
                                </p>
                            </li>
                            <li>
                                <p className="left">
                                    Duur les:
                                </p>
                                <p className="right">
                                    {this.typeOptionList("Duur les")}
                                </p>
                            </li>
                            <li>
                                <p className="left">
                                    Didactisch principe:
                                </p>
                                <p className="right">
                                    {this.typeOptionList("Didactisch Principe")}
                                </p>
                            </li>
                            <li>
                                <p className="left">
                                    Breinwaarde:
                                </p>
                                <p className="right">
                                    {this.typeOptionList("Breinwaarde")}
                                </p>
                            </li>
                            <li>
                                <p>
                                    * Zoeken van fouten in het werk van studenten<br/>
                                    ** Afhankelijk van het aantal zinnen: 5-10 minuten.
                                </p>
                            </li>
                        </ul>
                    </section>


                </main>
                }
            </div>
        )
    }
}

export default MethodCardScreen;